<template>
  <div>
    <el-form ref="form" :model="formData" size="mini" :disabled="disabled">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_deviceId') || '设备编号'"
            prop="deviceId"
          >
            <el-input v-model="formData.deviceId"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_ip') || 'ip地址'">
            <el-input v-model="formData.ip"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_versionNo') || '版本编号'"
            prop="versionNo"
          >
            <el-input v-model="formData.versionNo"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_versionName') || '版本名称'"
            prop="versionName"
          >
            <el-input v-model="formData.versionName"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_userName') || '用户名称'"
            prop="userName"
          >
            <el-input v-model="formData.userName"> </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_statusTime') || '最后一次状态时间'"
            prop="statusTime"
          >
            <el-input v-model="formData.statusTime"> </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_deviceInfo') || '设备信息'"
            prop="deviceInfo"
          >
            <el-input
              v-model="formData.deviceInfo"
              type="textarea"
              :autosize="{ minRows: 3 }"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    deviceStatusCode: String,
    params: { type: Object, default: () => {} },
  },
  components: {},
  data() {
    return {
      formData: { forceUpdate: 'Y', platform: 'Android' },
    }
  },
  mounted() {
    this.getData()
  },
  computed: {},
  methods: {
    getData() {
      if (!this.deviceStatusCode) return

      this.$api
        .appDeviceStatusDetailApi({
          deviceStatusCode: this.deviceStatusCode,
        })
        .then((res) => {
          this.formData = res.body
          const { fileName, downloadUrl } = res.body
          this.listFile = [{ name: fileName, url: downloadUrl }]
        })
    },

    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    },
  },
}
</script>
<style scoped lang="scss">
// 调整样式
:deep(.ql-editor) {
  min-height: 140px;
}

:deep(.ql-toolbar.ql-snow) {
  padding: 0px;
}
::v-deep .ql-editor {
  min-height: 150px;
}
</style>
